import { IContext } from 'overmind';
import { createActionsHook, createEffectsHook, createReactionHook, createStateHook } from 'overmind-react';
import { namespaced, merge } from 'overmind/config';

import { state, actions, effects } from 'src/state/app';

import { gql, subscriptions } from 'src/state/gql';

import * as users from 'src/state/users'
import * as tenants from 'src/state/tenants'
import * as areas from 'src/state/areas'
import * as bookings from 'src/state/bookings'
import * as guidelines from 'src/state/guidelines'
import * as threads from 'src/state/threads'
import * as messages from 'src/state/messages'
import * as blackouts from 'src/state/blackouts'
import * as documents from 'src/state/documents'

export const AppModules = {
    users,
    tenants,
    areas,
    guidelines,
    bookings,
    threads,
    messages,
    blackouts,
    documents
} 

export const AppStateConfig = merge(
    {
        state,
        actions,
        effects: {
            ...effects,
            gql,
            subscriptions
        }
    }, 
    namespaced(AppModules)
)

export const useAppState = createStateHook<IContext<typeof AppStateConfig>>()
export const useActions = createActionsHook<IContext<typeof AppStateConfig>>()
export const useEffects = createEffectsHook<IContext<typeof AppStateConfig>>()
export const useReaction = createReactionHook<IContext<typeof AppStateConfig>>()